import { DisplayNames } from 'Roblox';
import { concatTexts } from 'core-utilities';
import recommendationsModule from '../recommendationsModule';

function creatorNameUtilities(itemListConstants) {
  'ngInject';

  return {
    getNameForDisplay: creator => {
      const { userTypes, systemRobloxId } = itemListConstants;
      const { name, creatorType, creatorId } = creator;
      return userTypes[1] === creatorType && systemRobloxId !== creatorId && DisplayNames.Enabled()
        ? concatTexts.concat(['', name])
        : name;
    }
  };
}

recommendationsModule.factory('creatorNameUtilities', creatorNameUtilities);
export default creatorNameUtilities;
